<template>
  <footer>
    <div class="foot ">

      <div class="zz_blocks" style="width: calc(100% - 50px); padding: 0 10px;margin-top: 10px;
">


        <div class="  bottomline">
          <div class="d-flex justify-content-between flex-wrap align-items-center">

            <!--            <router-link to="/" style="" class="mainlink">-->
            <!--              <svg width="36" height="30" viewBox="0 0 36 30" fill="none"-->
            <!--                   xmlns="http://www.w3.org/2000/svg">-->
            <!--                <path-->
            <!--                    d="M34.2653 0.483005C33.9444 0.87401 27.4413 9.69077 25.4698 12.3588H21.1675L29.153 1.53335H24.973L16.9875 12.3588H12.7234C14.6873 9.66011 20.6249 1.53335 20.6249 1.53335H11.3021C10.0641 1.53335 9.06304 1.57935 8.29123 1.67902C7.51942 1.77869 6.87752 2.02402 6.38081 2.41503C5.87646 2.79836 5.47909 3.38104 5.18871 4.15538C4.89832 4.92972 4.62322 5.98773 4.37105 7.32175L3.17894 7.26041V5.32073C3.17894 4.42372 3.15602 3.58037 3.11781 2.78303C3.07196 1.98569 3.01083 1.06568 2.92677 0.00766675C3.79792 0.00766675 33.8909 0 33.8909 0L34.2653 0.483005Z"-->
            <!--                    fill="#AD6766"/>-->
            <!--                <path fill-rule="evenodd" clip-rule="evenodd"-->
            <!--                      d="M36 22.7549C35.4957 24.2883 35.1059 25.699 34.8385 27.0023C34.5634 28.3056 34.4105 29.3023 34.3647 30H23.6892H22.5888H0.282743L0 29.5247C0.443218 28.988 11.5848 14.1375 11.6918 13.9918H15.1458H22.2679H24.3617C23.9796 14.5132 13.755 28.413 13.7474 28.4206H19.5857H22.5888H23.6892H26.5549C27.4107 28.4206 28.2208 28.3363 28.9849 28.1676C29.7491 27.999 30.4674 27.6923 31.1475 27.2476C31.8276 26.7953 32.4695 26.1896 33.0809 25.4153C33.6846 24.6333 34.2501 23.6519 34.7773 22.4636L36 22.7549ZM18.8444 15.5175L9.32286 28.4206H5.14286L14.6644 15.5175H18.8444Z"-->
            <!--                      fill="#AD6766"/>-->
            <!--              </svg>-->

            <!--            </router-link>-->
            <div class="d-none d-md-block">
              Z&Z Agentur Dresden
            </div>
            <div class="d-block d-xl-none">
              <router-link to="/kontakt">
                Kontakt
              </router-link>
            </div>
            <div class="d-none d-xl-block">
              Micktner Str. 20, 01139 Dresden, Germany
            </div>
            <div class="d-none d-xl-block">
              <a href="tel:+493518588137"> Tel. +49 351 8588 137
              </a>
            </div>
            <div class="d-none d-xl-block">
              <a href="mailto:design@zzagentur.de">

              design@zzagentur.de
              </a>
            </div>
            <div class="">
              <router-link to="/impressum"> Impressum</router-link>

            </div>
            <div class="">
              <router-link to="/datenschutz"> Datenschutz</router-link>

            </div>

          </div>

        </div>

        <!--    <div class="widewidth bottomline ">-->
        <!--      <div class="d-flex justify-content-around align-items-center">-->

        <!--        <router-link to="/datenschutz">Datenschutzerklärung</router-link>-->
        <!--      </div>-->
        <!--    </div>-->
      </div>

    </div>
  </footer>
</template>
<script>
import store from '@/store'

export default {
  store,
  name: 'Footer.vue',
  data() {
    return {}
  },
  created: function () {
  },
  methods: {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>

a {
  color: #aaa !important;

  &:hover {
    font-weight: 600;
    color: $zzcolor;
  }
}

footer {
  //border-top: 1px solid $zzcolor;
  position: fixed;
  bottom: 0;

  width: 100%;
  background-color: transparent;
  background-color: #333;

}

h2 {
  margin-bottom: 0;
}

.foot {
  position: relative;
  margin: 0 auto;

  padding-left: 20px;
  padding-right: 20px;
  max-width: 100%;
  justify-content: space-between;
  display: flex;

  color: #fff;
  padding-bottom: 10px;

  h2 {
    color: #fff;
    text-align: center;
    border: none;
    font-weight: 400;
  }

  .zz_blocks {
    @include mobile {
      width: 100% !important;

      margin: 5px 0 !important;
    }
  }

  .bottomline {
    //border-top: 1px solid rgba(#fff, 0.8);
    //margin-top: 50px;
    @include mobile {
      margin-bottom: 0;
    }
    margin-bottom: 0;

    & > div {
      padding: 0 10px;
      @include mobile {
        padding-top: 5px;
      }

      div {
        padding: 0 10px;
        color: #888;
        text-align: center;
        font-size: 18px;
        line-height: 22px;
        border-right: 1px transparent solid;

        &:last-child {
          padding-right: 0;
          border: none;
        }

        @include mobile {
          border: none;
          padding-right: 0;
        }
      }
    }
  }

  .inner {
    max-width: 100%;
    width: 1280px;
  }

  .btn {
    margin-bottom: 50px;

    font-size: 18px;
    line-height: 120%;
    /* or 14px */
    border: 1px solid #AD6766;
    box-sizing: border-box;
    border-radius: 100px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    padding: 5px 10px;
    /* ZZ - Rostrot - heller */
    color: #AD6766;
    background-color: transparent;

    &:focus, &:hover {
      background-color: #ad6766;
      color: #fff;

      svg path {
        stroke: #fff;
      }
    }

  }
}
</style>
